// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeFilledSvg from "@ant-design/icons-svg/es/asn/CodeFilled";
import AntdIcon from '../components/AntdIcon';

var CodeFilled = function CodeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeFilledSvg
  }));
};

CodeFilled.displayName = 'CodeFilled';
export default React.forwardRef(CodeFilled);